<div class="confirm-modal ig-modal event-spider-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div>
        <div class="title">Event Pages for {{ account.account.userName }}</div>
        <div class="flex space-between m-b-3" style="width: 74%">
            <div class="limit" style="margin-right: 100px">
                <mat-form-field appearance="fill">
                    <input type="text" placeholder="Pick one" matInput [formControl]="myControl"
                        [matAutocomplete]="auto" />
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                        <mat-option *ngFor="let item of timezoneSourceFiltered | async" [value]="item.name">
                            {{ item.name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <ig-button size="md" [isAsync]="true" (trigger)="setTimezone($event)">
                    Save
                </ig-button>
            </div>

            <div class="limit">
                <!--            <ig-field label="Event pages limit" [(ngModel)]="limit" type="number" [formControl]="form.get('limit')"></ig-field>-->
                <ig-select #limitSelect [(ngModel)]="pagesLimitSource" label="Facebook Event pages limit"
                    (itemSelected)="limitChanged($event)"></ig-select>
                <ig-button size="md" [isAsync]="true" (trigger)="setLimit($event)">
                    Save
                </ig-button>
            </div>

            <div>
                <mat-checkbox [(ngModel)]="isAllowOnlineEvents" (ngModelChange)="changeAllowOnlineEvents()">Is Allow
                    Online Events</mat-checkbox>
            </div>
        </div>
        <mat-tab-group (selectedIndexChange)="tabChanged($event)">
            <mat-tab>
                <ng-template mat-tab-label>
                    Facebook
                </ng-template>
                <ig-spinner *ngIf="loading"></ig-spinner>
                <div class="m-t-3">
                    <ig-multi-fields *ngIf="pages" [group]="pages.facebook" [limit]="limit"></ig-multi-fields>
                </div>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    Eventbrite
                </ng-template>
                <ig-spinner *ngIf="loading"></ig-spinner>
                <div class="m-t-2">
                    <div class="m-b-2" style="width: 90%;">
                        <div>
                            <ig-field label="Enter multiple Eventbrite event IDs or URLs, separated by semicolons."
                                [required]="false" [(ngModel)]="eventbriteEventIdsOrUrls"
                                [formControl]="form.get('eventbriteEventIdsOrUrls')">
                            </ig-field>
                        </div>
                        <div>
                            <ig-button size="md" [isAsync]="true" (trigger)="pullEventbriteEvent($event)">
                                Pull
                            </ig-button>
                            <p class="text-left" style="margin-top: 5px;color: red;" *ngIf="errorMessage">
                                {{errorMessage}}
                            </p>
                        </div>
                    </div>
                    <p class="text-left m-b-2">Last pulled time: {{
                        lastRunTime && lastRunTime.eventbriteLastRunTime ?
                        parseTime(lastRunTime.eventbriteLastRunTime) : 'N/A'
                        }}</p>
                    <ig-list style="max-height: 400px;display:block;overflow:auto">
                        <div header>
                            <ig-row style="text-align:left">
                                <ig-col [xs]="10" [md]="6">Eventbrite pages</ig-col>
                                <ig-col [xs]="2" [md]="2">City code</ig-col>
                            </ig-row>
                            <div (click)="addEventbriteCityCode()"
                                style="position:absolute;right: 24px;top: 140px;color:deepskyblue;cursor:pointer;font-size: 18px;">
                                + Add
                            </div>
                        </div>
                        <div *ngIf="pages" body class="account-list overflow-auto">
                            <ig-list-item *ngFor="let page of pages.eventbrite">
                                <ig-row style="text-align:left">
                                    <ig-col [xs]="10" [md]="6">{{ page.url }}</ig-col>
                                    <ig-col [xs]="2" [md]="2">{{ page.tag || '(not set)' }}</ig-col>
                                </ig-row>
                                <ig-row-action-buttons style="width:160px;position:absolute;right:0;top:0">
                                    <mat-icon *ngIf="testingEventbritePage !== page" matTooltip="Test pull events"
                                        (click)="testEventbritePage(page)">
                                        cloud_download
                                    </mat-icon>
                                    <mat-icon *ngIf="testingEventbritePage === page" class="ig-spin"
                                        matTooltip="Pulling events...">
                                        autorenew
                                    </mat-icon>
                                    <mat-icon matTooltip="Edit" (click)="editEventbriteCityCode(page)">
                                        edit
                                    </mat-icon>
                                    <mat-icon matTooltip="Remove" (click)="removeEventbriteCityCode(page)">
                                        delete
                                    </mat-icon>

                                </ig-row-action-buttons>
                            </ig-list-item>
                        </div>
                    </ig-list>
                </div>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    AI Event Aggregator
                </ng-template>
                <ig-spinner *ngIf="loading"></ig-spinner>
                <div>
                    <div *ngIf="pages" class="m-t-3">
                        <div class="flex flex-col m-b-2" style="align-items:baseline">
                            <p style="color:#99abb4;font-size:16px;margin-bottom:4px">Type</p>
                            <select name="" id="" style="width:200px;height:32px" [(ngModel)]="serpGoogleType">
                                <option value="city">City</option>
                                <option value="keywords">Keywords</option>
                            </select>
                        </div>
                        <div *ngIf="serpGoogleType==='city'" class="serp">
                            <ig-multi-fields #multipleFieldsComponent [group]="serpGoogleCityPages"
                                [limit]="serpCityLimit" label="City to pull, e.g., Savannah, GA"
                                (onAdd)="citySelector.clear()"></ig-multi-fields>
                            <div class="flex">
                                <ig-city-selector #citySelector type="text" [searchType]="'geocode'"
                                    label="type and select a city from the dropdown" [(ngModel)]="enteredCity"
                                    [isRequired]="false" [innerLabel]="true" (ngModelChange)="citySelected()"
                                    [formControl]="form.get('city')"></ig-city-selector>
                                <ig-button test size="md" [isAsync]="true" (trigger)="testSerpGoogle($event)">Test
                                </ig-button>
                            </div>
                        </div>
                        <div *ngIf="serpGoogleType==='keywords'" keywords>
                            <ig-multi-fields #keywordsMultipleFieldsComponent [group]="serpGoogleKeywordsPages"
                                [limit]="serpCityLimit" (onAdd)="onAddKeywordsPage($event)"
                                (onRemove)="onRemoveKeywordsPage($event)"
                                label="keywords to pull, e.g., Cincinnati red events"></ig-multi-fields>
                            <ig-city-selector #citySelector class="serp-keywords-city-selector" type="text" [searchType]="'geocode'"
                                label="select a city for filtering" [(ngModel)]="serpGooglekeywordsCity"
                                [isRequired]="false" [innerLabel]="true"
                                [formControl]="form.get('city')"></ig-city-selector>
                            <ig-button keywordstest size="md" [isAsync]="true"
                                (trigger)="testSerpGoogleKeywords($event)">Test
                            </ig-button>
                        </div>
                    </div>
                    
                    <div class="m-t-3" style="text-align: left">
                        <mat-checkbox class="m-b-1" [(ngModel)]="account.account.facebookFeeds.blockKeywords.isUseOwn"
                            (ngModelChange)="isUseOwnKeywordsChanged()">Use own keywords
                        </mat-checkbox>
                        <mat-icon style="color:lightgray"
                            matTooltip="Please notice this will be applied only to the events to be pulled in the future. If you want to block existing events, please use the block keywords feature in the client dashboard">
                            info
                        </mat-icon>
                        <ig-multi-fields *ngIf="account.account.facebookFeeds.blockKeywords.isUseOwn" class="m-t-3"
                            [group]="account.account.facebookFeeds.blockKeywords.keywords"
                            label="Block keywords for this account, separate with comma, e.g., church, faith, gospel"
                            (onAdd)="citySelector.clear()"></ig-multi-fields>
                        <ig-multi-fields *ngIf="!account.account.facebookFeeds.blockKeywords.isUseOwn" class="m-t-3"
                            [group]="serpBlockKeywords"
                            label="Block keywords for all accounts, separate with comma, e.g., church, education, ad"
                            (onAdd)="citySelector.clear()"></ig-multi-fields>
                    </div>
                </div>
            </mat-tab>
            <!--            be careful moving this tab, the tabChanged function is dependent on it-->
            <mat-tab *ngIf="isOpenRegionalAccountType">
                <ng-template mat-tab-label>
                    DMO Approved Events Data (Regional Accounts)
                </ng-template>
                <ig-spinner *ngIf="loading"></ig-spinner>
                <div class="m-t-3 ig-regional-accounts">
                    <ig-multi-fields *ngIf="accounts.length" [group]="regionalAccounts" [limit]="regionalAccountLimit"
                        label="DMO accounts you want to add to this regional account"
                        (onAdd)="onAddRegionalAccount($event)" [autoCompleteSource]="accounts"></ig-multi-fields>
                    <mat-checkbox [(ngModel)]="isSyncEventAfterAddingDMOAccounts">
                        Copy/remove DMO events to/from this regional account after adding/removing DMO accounts
                    </mat-checkbox>
                </div>
            </mat-tab>

            <mat-tab>
                <ng-template mat-tab-label>
                    Event Aggregator API Keys
                </ng-template>
                <div class="event-aggregator-credentials m-t-3">
                    <p>
                        These credentials are used only for this account. Leave a field blank to keep its current value.
                    </p>
                    <ig-field
                        label="OpenAI Batch Organization ID"
                        [placeholder]="eventAggregatorCredentials.batchOrganizationId || 'org-...'"
                        [formControl]="form.get('eventAggregatorBatchOrganizationId')"
                        [(ngModel)]="eventAggregatorBatchOrganizationId">
                    </ig-field>
                    <ig-field
                        type="text"
                        label="OpenAI Batch API key"
                        [placeholder]="eventAggregatorCredentials.batchApiKeyConfigured ? 'Configured (ends in ' + eventAggregatorCredentials.batchApiKeyLastFour + ')' : 'Not configured'"
                        [formControl]="form.get('eventAggregatorBatchApiKey')"
                        [(ngModel)]="eventAggregatorBatchApiKey">
                    </ig-field>
                    <ig-field
                        type="text"
                        label="OpenAI AI Image API key"
                        [placeholder]="eventAggregatorCredentials.imageApiKeyConfigured ? 'Configured (ends in ' + eventAggregatorCredentials.imageApiKeyLastFour + ')' : 'Not configured'"
                        [formControl]="form.get('eventAggregatorImageApiKey')"
                        [(ngModel)]="eventAggregatorImageApiKey">
                    </ig-field>
                    <ig-button size="md" [isAsync]="true" (trigger)="saveEventAggregatorCredentials($event)">
                        Save API Keys
                    </ig-button>
                    <section *ngIf="eventAggregatorUrlEnabled" class="m-t-3">
                        <h3>Event listing URLs</h3>
                        <p>OpenAI researches these public listing URLs and their event detail pages. One URL per line, up to {{ eventAggregatorMaxSources }}.
                            Events must match this account's configured Serp Google Cities. Clear the field to remove all sources.</p>
                        <label for="event-aggregator-listing-urls">Listing URLs</label>
                        <textarea id="event-aggregator-listing-urls" rows="6" style="width: 100%"
                            [formControl]="form.get('eventAggregatorListingUrls')"></textarea>
                        <p *ngIf="eventAggregatorSourcesError" role="alert">{{ eventAggregatorSourcesError }}</p>
                        <ig-button size="md" [isAsync]="true" (trigger)="saveEventAggregatorSources($event)">
                            Save Listing URLs
                        </ig-button>
                    </section>
                </div>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    Job Keywords
                </ng-template>
                <div keywords>
                    <ig-multi-fields [group]="jobKeywordsDisplayText"
                            [limit]="serpCityLimit" (onAdd)="onAddJobKeywords($event)"
                            (onRemove)="onRemoveJobKeywords($event)"
                            label="keywords to pull jobs, e.g., Health Rehab"></ig-multi-fields>
                    <ig-city-selector #citySelector class="serp-keywords-city-selector" type="text" [searchType]="'geocode'"
                            label="select a city for filtering" [(ngModel)]="jobKeywordsCity"
                            [isRequired]="false" [innerLabel]="true"
                            [formControl]="form.get('city')"></ig-city-selector>
                    <div class="flex justify-end ig-job-keywords-save-button">
                        <ig-button size="md" [isAsync]="true" (trigger)="saveJobKeywords($event)" style="width: 200px">
                            Save Job Keywords
                        </ig-button>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
    <div *ngIf="!isJobKeywordsTabSelected" class="action-row flex">
        <ig-button class="m-l-3" color="cancel" (trigger)="close()">
            Cancel
        </ig-button>
        <ig-button size="md" [isAsync]="true" (trigger)="confirm($event)">
            Save
        </ig-button>
    </div>
</div>



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/event.spider/event.spider.modal.component.html